import { useEffect, useState } from "react";

function useIsMobile(breakpoint = 768) {
	const query = `(max-width: ${breakpoint}px)`;

	const getMatches = () => window.matchMedia(query).matches;
	const [isMobile, setIsMobile] = useState(getMatches);

	useEffect(() => {
		const mql = window.matchMedia(query);

		const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

		setIsMobile(mql.matches);

		if (mql.addEventListener) mql.addEventListener("change", onChange);
		else mql.addListener(onChange);

		return () => {
			if (mql.removeEventListener) mql.removeEventListener("change", onChange);
			else mql.removeListener(onChange);
		};
	}, [query]);

	return isMobile;
}

export default useIsMobile;